<div class="container-fluid admin-page map-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Live map' | translate }}</h1>
            <p>{{ 'Locate active cars and focus the map on a selected car.' | translate }}</p>
        </div>
    </header>

    <section class="map-toolbar admin-toolbar">
        <label class="car-selector admin-filter-field">
            <span>{{ 'Car ID' | translate }}</span>
            <div class="car-select-wrap">
                <i class="material-icons car-select-icon">directions_car</i>
                <input (blur)="closeCarDropdown()"
                       (focus)="openCarDropdown()"
                       (keydown.enter)="selectFirstFilteredCar($event)"
                       (ngModelChange)="onCarSearchChanged($event)"
                       [disabled]="isLoadingCars"
                       [ngModel]="carSearchText"
                       aria-autocomplete="list"
                       [attr.aria-label]="'Search and select a car ID' | translate"
                       autocomplete="off"
                       [placeholder]="'Search car ID' | translate"
                       role="combobox"
                       type="search">
                <button (click)="toggleCarDropdown()"
                        (mousedown)="$event.preventDefault()"
                        [disabled]="isLoadingCars"
                        [attr.aria-label]="'Toggle Car ID options' | translate"
                        class="car-select-toggle"
                        type="button">
                    <i class="material-icons">{{ isCarDropdownOpen ? 'expand_less' : 'expand_more' }}</i>
                </button>
                <div *ngIf="isCarDropdownOpen" class="car-options" role="listbox">
                    <button (mousedown)="selectCar(carId); $event.preventDefault()"
                            *ngFor="let carId of filteredCarIds"
                            [attr.aria-selected]="carId === selectedCarId"
                            [class.selected]="carId === selectedCarId"
                            role="option"
                            type="button">{{ carId }}
                    </button>
                    <span *ngIf="filteredCarIds.length === 0"
                          class="no-car-options">{{ 'No matching Car IDs' | translate }}</span>
                </div>
            </div>
        </label>
        <button (click)="resetCarSelection()"
                [disabled]="selectedCarId === '' && carSearchText === '' && resultOfSelection === ''"
                class="reset-filter-button" type="button">
            <i class="material-icons">filter_alt_off</i><span>{{ 'Reset' | translate }}</span>
        </button>
        <div *ngIf="resultOfSelection !== ''" class="selection-result" role="status">
            <i class="material-icons">location_off</i>
            <span>{{ resultOfSelection | translate }}</span>
        </div>
    </section>

    <section class="map-shell">
        <google-map [center]="mapCenter" [zoom]="zoom" height="100%" width="100%">
            <map-marker #carMapMarker
                        (mapClick)="clickedMarker(m, carMapMarker)"
                        *ngFor="let m of markers; let i = index; trackBy: trackByItems"
                        [label]="m.labelOptions"
                        [options]="m.options"
                        [position]="m.position">
            </map-marker>
            <map-info-window #carInfoWindow>
                <div *ngIf="selectedMapMarker" class="car-info-window">
                    <strong>{{ getMarkerTitle(selectedMapMarker) }}</strong>
                    <ng-container *ngIf="selectedMapMarker.isBusy">
                        <span *ngIf="selectedMapMarker.isLoadingOrder" class="car-order-state">
                            <i class="material-icons spinning">refresh</i>{{ 'Loading active order...' | translate }}
                        </span>
                        <button (click)="openOrderDetails(selectedMapMarker.activeOrder, $event)"
                                *ngIf="!selectedMapMarker.isLoadingOrder && selectedMapMarker.activeOrder"
                                [attr.aria-label]="'Open order details' | translate"
                                class="car-order-link" type="button">
                            {{ getOrderIdentifier(selectedMapMarker.activeOrder) }}
                        </button>
                        <span *ngIf="!selectedMapMarker.isLoadingOrder && selectedMapMarker.orderLookupComplete
                            && !selectedMapMarker.activeOrder" class="car-order-state unavailable">
                            {{ 'Active order unavailable.' | translate }}
                        </span>
                    </ng-container>
                </div>
            </map-info-window>
        </google-map>
    </section>
</div>

<app-order-details (closed)="closeOrderDetails()" [order]="selectedOrder"></app-order-details>
